import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { TagCategoryManager } from "@/components/settings/TagCategoryManager";
import type { ReactNode } from "react";

type Props = {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: ReactNode;
};

/**
 * Sheet wrapper that surfaces the workspace Tags (and, until Stage 6, Topics)
 * manager at point-of-use on the Excerpts page. Replaces the old Settings
 * → Workspace card. See mem://features/topics-are-codex-driven.md.
 */
export function TagsManagerSheet({ open, onOpenChange, trigger }: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      {trigger ? <SheetTrigger asChild>{trigger}</SheetTrigger> : null}
      <SheetContent className="w-full sm:max-w-xl overflow-y-auto">
        <SheetHeader className="space-y-1.5">
          <SheetTitle>Manage tags</SheetTitle>
          <SheetDescription>
            Rename, merge, or delete tags used across this workspace's excerpts.
          </SheetDescription>
        </SheetHeader>
        <div className="mt-4">
          <TagCategoryManager />
        </div>
      </SheetContent>
    </Sheet>
  );
}
